import styled from 'styled-components';

export const StyledHeaderRow = styled.div`
  display: flex;
  align-items: center;

  .img-wrapper {
    width: 120px;
    height: 80px;
    margin-right: 24px;

    display: flex;
    align-items: center;
    justify-content: center;

    border: 1px solid ${({ theme }) => theme.color.border.regular};
    border-radius: ${({ theme }) => theme.radius.small}px;
    overflow: hidden;
    background: ${({ theme }) => theme.color.surface.background};

    img {
      width: 100%;
      height: auto;
      object-fit: scale-down;
    }
  }
`;
